import React from 'react'

import { Divider, Toggle } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, func, oneOf, string,
} from 'prop-types'

import { MODE } from 'Pods/LazyLoaded/AuthModal/constants'
import i18n from 'Pods/Shared/I18n'

import EmailField from './Components/EmailField/EmailField'
import Footer from './Components/Footer/Footer'
import Header from './Components/Header/Header'
import SocialButtons from './Components/SocialButtons/SocialButtons'
import TermsNotice from './Components/TermsNotice/TermsNotice'

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

function AuthStep({
  mode,
  email,
  optIn,
  locale = 'en',
  onEmailChange,
  onOptInChange,
  onSubmit,
  onSocial,
  onSwitchMode,
  onSwitchToPassword,
}) {
  const isSignup = mode === MODE.SIGNUP
  const t = key => i18n.t(`auth_modal.${key}`, { ns: 'rails', lng: locale })
  const isEmailValid = EMAIL_REGEX.test(email.trim())

  const handleSubmit = (event) => {
    event.preventDefault()
    if (isEmailValid) {
      onSubmit()
    }
  }

  // The switch toggle keeps DOM focus across the mode change (React reuses the
  // node), so move focus to the email field - mirroring the autoFocus on open.
  const handleSwitchMode = () => {
    onSwitchMode()
    document.getElementById('sign-in-email')?.focus()
  }

  return (
    <form className="auth-modal__auth" onSubmit={handleSubmit} noValidate>
      <Header isSignup={isSignup} locale={locale} />
      <SocialButtons onSocial={onSocial} />
      <Divider customClass="auth-modal__divider" childrenPosition="center">
        <span className="auth-modal__divider-text cgt-caption-semibold">{t('social_divider')}</span>
      </Divider>
      <EmailField value={email} locale={locale} onChange={onEmailChange} />
      {isSignup && (
        <Toggle
          id="sign-in-opt-in"
          isChecked={optIn}
          onChange={(_, checked) => onOptInChange(checked)}
          label={t('opt_in_label')}
          labelClassName="auth-modal__opt-in-label cgt-body-base"
        />
      )}
      <Footer
        isSignup={isSignup}
        canSubmit={isEmailValid}
        locale={locale}
        onSwitchMode={handleSwitchMode}
        onSwitchToPassword={onSwitchToPassword}
      />
      {isSignup && <TermsNotice locale={locale} />}
    </form>
  )
}

AuthStep.propTypes = {
  mode: oneOf([MODE.SIGNUP, MODE.LOGIN]).isRequired,
  email: string.isRequired,
  optIn: bool.isRequired,
  locale: string,
  onEmailChange: func.isRequired,
  onOptInChange: func.isRequired,
  onSubmit: func.isRequired,
  onSocial: func.isRequired,
  onSwitchMode: func.isRequired,
  onSwitchToPassword: func.isRequired,
}

export default AuthStep
